import { getRequest, postRequest, pathname } from "@react/helpers/fetch"

export const fetchFormData = () =>
  getRequest("/purchase_orders/form_data.json")

export const fetchCategoryFields = (categoryId) =>
  getRequest(pathname({
    path:   "/purchase_orders/property_fields",
    format: "json",
    params: categoryId ? { category_id: categoryId } : {},
  }))

export const fetchOrderableBreakdowns = (projectId) =>
  getRequest(pathname({
    path:   "/purchase_orders/orderable_breakdowns",
    format: "json",
    params: { project_id: projectId },
  }))

export const createPurchaseOrder = (projectId, purchaseOrder, commit) =>
  postRequest({
    url:  "/purchase_orders.json",
    body: { purchase_order: { ...purchaseOrder, project_id: projectId }, commit },
  })

export const fetchPurchaseOrderShow = (id) =>
  getRequest(`/purchase_orders/${id}.json`)

export const sendPurchaseOrderEmail = (id, body) =>
  postRequest({ url: `/purchase_orders/${id}/send_email.json`, body })
